/* eslint-disable @typescript-eslint/no-unused-vars */
import { computed } from "vue";
import { useCommonStore } from '@/store'

export default function useIsUserAuth(): boolean {
  const commonStore = useCommonStore()
  const isUserAuth = computed<boolean>(() => Boolean(commonStore.user))
  return isUserAuth.value;
}
